var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "py-5 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon-check-circle.svg")
    }
  }), _c('div', {
    staticClass: "mt-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.preorderSetting, 'config.finish_page.form_title')))]), _c('p', {
    staticClass: "one-line-note"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.preorderSetting, 'config.finish_page.form_desc')))])]), _c('section', {
    staticClass: "custom-note-section",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.preorderSetting, 'config.finish_page.content'))
    }
  }), _c('div', {
    staticClass: "sticky-bottom footer-action-bar"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.deepGet(_vm.preorderSetting, 'config.finish_page.button_text'),
      "button-url": _vm.deepGet(_vm.preorderSetting, 'config.finish_page.button_url'),
      "type": _vm.deepGet(_vm.preorderSetting, 'config.finish_page.button_action')
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }